import {
  RuleValidation,
  RuleValidationContext,
} from '../../CampaignModalSkeleton/CampaignModalSkeleton.types';
import { BNGM_SCOPE, BuyNGetMRuleState } from './types';
import { BNGM_OPTION_LISTS_ERROR_MESSAGE } from './bngmOptionLists';

export function validateBuyNGetMRule(
  rule: BuyNGetMRuleState,
  context?: RuleValidationContext,
): RuleValidation {
  if (rule.scopeType === BNGM_SCOPE.PRODUCTS && rule.products.length === 0) {
    return { isValid: false, errors: { products: 'empty' } };
  }
  if (rule.scopeType === BNGM_SCOPE.OPTIONS) {
    const eligibility = context?.bngmOptionListEligibility;

    if (eligibility?.loading) {
      return {
        isValid: false,
        errors: {
          optionList:
            "Les listes d'options éligibles sont en cours de chargement.",
        },
      };
    }

    if (eligibility?.error) {
      return {
        isValid: false,
        errors: { optionList: BNGM_OPTION_LISTS_ERROR_MESSAGE },
      };
    }

    if (!rule.selectedOptionListKey) {
      return {
        isValid: false,
        errors: {
          optionList: "Veuillez sélectionner une liste d'options éligible.",
        },
      };
    }

    if (
      eligibility &&
      !eligibility.eligibleKeys.includes(rule.selectedOptionListKey)
    ) {
      return {
        isValid: false,
        errors: {
          optionList:
            "La liste d'options sélectionnée n'est plus éligible pour les points de vente ciblés.",
        },
      };
    }
  }
  if (rule.numProductsPaid < 1) {
    return { isValid: false, errors: { numProductsPaid: 'invalid' } };
  }
  if (rule.numProductsDiscounted < 1) {
    return { isValid: false, errors: { numProductsDiscounted: 'invalid' } };
  }
  if (rule.numProductsPaid + rule.numProductsDiscounted < 2) {
    return { isValid: false, errors: { numProductsPaid: 'invalid' } };
  }
  if (rule.discountPercent < 1 || rule.discountPercent > 100) {
    return { isValid: false, errors: { discountPercent: 'invalid' } };
  }
  return { isValid: true, errors: {} };
}
